export var MAX_SELECTION_SIZE = 5000;
